import { render } from "./MobileFilterMenu.vue?vue&type=template&id=b6cb15a0&bindings={\"categories\":\"props\",\"activeCategory\":\"props\",\"activeLanguage\":\"data\",\"expanded\":\"data\",\"otherLanguage\":\"options\",\"styleObject\":\"options\",\"setActiveLanguage\":\"options\",\"onFilterItemClick\":\"options\"}"
import script from "./MobileFilterMenu.vue?vue&type=script&lang=js"
export * from "./MobileFilterMenu.vue?vue&type=script&lang=js"
script.render = render

export default script